import { render, staticRenderFns } from "./index_2.vue?vue&type=template&id=455987a2&scoped=true"
import script from "./index_2.vue?vue&type=script&lang=js"
export * from "./index_2.vue?vue&type=script&lang=js"
import style0 from "./index_2.vue?vue&type=style&index=0&id=455987a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455987a2",
  null
  
)

export default component.exports